import React, { CSSProperties, MutableRefObject, useState } from 'react'
import styles from '~/styles/atoms/dropdown/dropdown.module.scss'
import { useSpring } from 'react-spring'
import { useOutsideClick } from '~/hooks/ouside'

import { getRect } from '~/common/utils/rect'
import { useWindowSize } from '~/hooks/window'
import { useRouteChanged } from '~/hooks/transition'

const BOTTOM_PADDING = 8

export const useDropDown = (leftSide = false):
  {clickableRef: MutableRefObject<any>, onClickOpen:() => void, close:() => void,
    dropDownStyles: CSSProperties, buttonClass: string, dropDownClass: string, open: boolean}  => {
  const [open, setOpen] = useState<boolean>(false)
  const clickableRef = useOutsideClick(() => setOpen(false))
  const onClickOpen = () => setOpen(true)
  const { width } = useWindowSize()
  const rect = getRect(clickableRef)

  const close = () => setOpen(false)

  const dropDownStyles = useSpring({
    opacity: open ? 1 : 0,
    display: open ? 'block' : 'none',
    left: (leftSide && rect && rect.left) ? rect.left : 'auto',
    right: (!leftSide && rect && rect.right && width) ? width - rect.right : 'auto',
    top: rect ? rect.bottom + BOTTOM_PADDING : 0,
  })
  
  useRouteChanged(() => {
    close()
  })

  return {clickableRef, onClickOpen, close, dropDownStyles, buttonClass: styles.button, dropDownClass: styles.dropdown, open}
}
